export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1742325646212-f917ba1feeaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxob3dyYWglMjBicmlkZ2UlMjBrb2xrYXRhJTIwc3VucmlzZXxlbnwwfHx8fDE3ODQyMDcyNDB8MA&ixlib=rb-4.1.0&q=85",
  origin: "https://images.unsplash.com/photo-1571679654681-ba01b9e1e117?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxob3dyYWglMjBicmlkZ2UlMjBrb2xrYXRhJTIwc3VucmlzZXxlbnwwfHx8fDE3ODQyMDcyNDB8MA&ixlib=rb-4.1.0&q=85",
};

export const DIVISIONS = [
  {
    id: "home-decor",
    name: "Home Decor",
    est: "Since 1977",
    image: "https://images.unsplash.com/photo-1638310533874-6c124c012e1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxjYXJwZXQlMjB3ZWF2aW5nJTIwY3JhZnRzbWFuc2hpcHxlbnwwfHx8fDE3ODQyMDcyNDB8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Our first major diversification, HAG Carpets entered the carpet industry in 1977, leveraging India's textile manufacturing expertise. From hand-crafted rugs to contemporary carpets, the division carries forward a tradition of local craftsmanship that dates back to the Group's Swadeshi origins.",
    companies: [{ name: "HAG Carpets", url: "https://www.hagcarpets.com" }],
  },
  {
    id: "footwear",
    name: "Footwear Products",
    est: "Since 1989",
    image: "https://images.unsplash.com/photo-1477517787936-70ba786643fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxsZWF0aGVyJTIwc2hvZW1ha2luZyUyMGNyYWZ0c21hbnxlbnwwfHx8fDE3ODQyMDcyNDB8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Established in 1989 as Titas Footwear & Leathercraft Industries, our associate company expanded the Group into footwear manufacturing and leather goods, followed by retail operations in 2007. In 2025, Titas Footwear secured private equity investment, bringing institutional capital to accelerate its growth.",
    companies: [
      { name: "Titas Footwear", url: "https://www.titasindia.com", note: "Associate company" },
    ],
  },
  {
    id: "fragrances",
    name: "Fragrances & Aromatics",
    est: "Since 2019",
    image: "https://images.unsplash.com/photo-1588405748880-12d1d2a59f75?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description:
      "Entering the perfume and cosmetics segment in 2019, the Group launched Youvora.com in 2022 — a dedicated luxury perfume platform — alongside Ag Perfume. The division brings refined fragrances and aromatics to consumers across India.",
    companies: [
      { name: "Youvora", url: "https://www.youvora.com" },
      { name: "Ag Perfume", url: "https://www.agperfume.com" },
    ],
  },
  {
    id: "real-estate",
    name: "Real Estate Development",
    est: "Since 2001",
    external: "https://myflexworx.com",
    image: "/assets/real-estate-arcadia.webp",
    description:
      "Since 2001, the Group has been active in real estate leasing and management, capitalising on India's growing urban development and infrastructure expansion. Through Arcadia's property tenancy management platform, we deliver professional, end-to-end management for property owners and tenants.",
    companies: [
      { name: "Arcadia — Property Tenancy Management", url: "https://myflexworx.com" },
    ],
  },
  {
    id: "tobacco",
    name: "Tobacco Consumables",
    est: "Heritage Division",
    image: "/assets/tobacco-nasirbiri.webp",
    description:
      "Rooted in the Group's earliest trading heritage, the tobacco consumables division operates through Nasir Biri and Eskay Biri — brands built on generations of trust and the SKNBM trademark registered in 1942.",
    companies: [
      { name: "Nasir Biri", url: "https://www.nasirbiri.com" },
      { name: "Eskay Biri", url: "https://www.eskaybiri.com" },
    ],
  },
  {
    id: "investments",
    name: "Investments & Securities",
    est: "Investment & Trading Division",
    image: "https://images.unsplash.com/photo-1560221328-12fe60f83ab8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGZpbmFuY2UlMjBjaGFydCUyMGdyb3d0aHxlbnwwfHx8fDE3ODQyMDcyNDB8MA&ixlib=rb-4.1.0&q=85",
    description:
      "SKN Group oversees diversified investment portfolios across equities and mutual funds, operating through its dedicated investment and trading division. Every decision is guided by a team of seasoned experts, ensuring disciplined management and the highest standards of security and trust.",
    companies: [],
  },
];

export const MILESTONES = [
  {
    year: "1928",
    title: "Founded in Kolkata",
    text: "Amid the uncertainties of pre-independence India, a young man's search for livelihood became intertwined with the nation's own pursuit of self-reliance. Founded in 1928 near the Howrah Bridge, SKN Group grew from humble beginnings into a reflection of the Swadeshi vision — promoting local craftsmanship and economic independence.",
  },
  {
    year: "1942",
    title: "SKNBM Trademark",
    text: "Registered the SKNBM trademark, formalising the company's brand identity and establishing a recognised business presence in the market.",
  },
  {
    year: "1968",
    title: "Private Limited Company",
    text: "Incorporated as a Private Limited company, providing the organisational structure needed for professional management and future expansion across multiple sectors.",
  },
  {
    year: "1977",
    title: "Entry into Carpets",
    text: "Launched HAG-Carpet, marking the first major diversification into the carpet industry and leveraging India's textile manufacturing expertise.",
  },
  {
    year: "1989",
    title: "Footwear & Leathercraft",
    text: "Established Titas Footwear & Leathercraft Industries (associate company), entering the footwear manufacturing sector and expanding the product portfolio into leather goods.",
  },
  {
    year: "2001",
    title: "Real Estate",
    text: "Entered real estate leasing and management, capitalising on India's growing urban development and infrastructure expansion opportunities.",
  },
  {
    year: "2007",
    title: "Footwear Retail",
    text: "Diversified into footwear retail operations, creating vertical integration between manufacturing and direct consumer sales channels (associate company).",
  },
  {
    year: "2019",
    title: "Perfumes & Cosmetics",
    text: "Entered the perfume and cosmetics segment, extending the Group's consumer presence into fragrances and aromatics.",
  },
  {
    year: "2022",
    title: "Youvora.com",
    text: "Launched Youvora.com, a dedicated luxury perfume platform, bringing refined fragrances directly to consumers across India.",
  },
  {
    year: "2025",
    title: "Private Equity Investment",
    text: "Titas Footwear secured private equity investment, bringing institutional capital and expertise to accelerate growth in the footwear division.",
  },
];

export const STATS = [
  { value: "97", suffix: "", label: "Years of Legacy" },
  { value: "6", suffix: "", label: "Divisions" },
  { value: "9,000", suffix: "+", label: "Employees" },
  { value: "8", suffix: "", label: "States" },
];

export const CONTACT = {
  address: "1, Ripon Street, Kolkata 700016, India",
  phone: "1800 12000 1400",
  phoneTel: "180012001400",
  email: "headoffice@skngroup.net",
  coordinates: "22.5448° N · 88.3576° E",
};

export const SUBJECT_OPTIONS = [
  "General Inquiry",
  "Home Decor",
  "Footwear Products",
  "Fragrances & Aromatics",
  "Real Estate Development",
  "Tobacco Consumables",
  "Investments & Securities",
];

export const CAREER_AREAS = [
  "General",
  "Home Decor",
  "Footwear Products",
  "Fragrances & Aromatics",
  "Real Estate Development",
  "Tobacco Consumables",
  "Investments & Securities",
];
